import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { CustomerAndCompany } from '../../customer/CustomerAndCompany'

@InputType()
export class SubCompanyInput {
  @Field(() => ID)
  _id: string

  @Field({ nullable: true })
  name?: string
}

@InputType()
export class UpdateCompanySubCompaniesArgs extends ActionArgs {
  @Field(() => ID)
  companyId: string

  @Field(() => [SubCompanyInput], { nullable: true })
  subCompanies?: SubCompanyInput[]
}

export interface IUpdateCompanySubCompanies extends IAction<CustomerAndCompany, UpdateCompanySubCompaniesArgs> {}
